import React, { useState } from 'react'

import { Form, Page, Text } from '@fielded/shared-ui'
import { Upload } from '@fielded/shared-ui/src/icons'

const ACCEPTED_FILE_TYPES =
  'vnd.ms-excel, vnd.openxmlformats-officedocument.spreadsheetml.sheet, csv'

const PSMShipmentExportImportUpload = ({
  documentFormRef,
  isUploading,
  onUpload,
  onCancel
}) => {
  const [hasValidFile, setHasValidFile] = useState(false)

  return (
    <Form ref={documentFormRef} component='form'>
      <Page.Panel.Section>
        <Text.Heading>Upload updated shipment file</Text.Heading>
        <Text>
          After filling in the shipment information in the downloaded template, upload the file here. Make sure all required fields are complete and the file is saved in the correct format (Excel) before uploading.
        </Text>
      </Page.Panel.Section>

      <Page.Panel.Section>
        <Form.Section>
          <Form.Row>
            <Form.Field
              fieldName='file'
            >
              <Form.Field.FileUploadAdvanced
                accept={ACCEPTED_FILE_TYPES}
                acceptText='.xls,.xlsx,.csv'
                required
                onValueChange={(value) => setHasValidFile(!!value)}
              />
              <Form.Field.ValidationErrors />
            </Form.Field>
          </Form.Row>
        </Form.Section>
        <Form.Actions />

      </Page.Panel.Section>
      <Page.Footer fixed>
        <Form.Actions className='new-psm-shipment__button-wrapper'>
          <Form.Button
            icon={<Upload />}
            loading={isUploading}
            onClick={onUpload}
            disabled={!hasValidFile}
          >
              Upload file
          </Form.Button>
          <Form.Button
            variant='deemphasized'
            alignOpposite
            onClick={onCancel}
          >
            Cancel and go back
          </Form.Button>
        </Form.Actions>
      </Page.Footer>
    </Form>
  )
}

export default PSMShipmentExportImportUpload
